import MUIMenuItem from '@mui/material/MenuItem';

type MenuItemProps = {
  children?: React.ReactNode;
  closeOnSelect?: boolean;
  icon?: any;
  isFocusable?: boolean;
  isDisabled?: boolean;
  command?: string;
  onClick?: (...args: any[]) => any;
  value?: string;
};

export default function MenuItem({
  children,
  ...props
}: Readonly<MenuItemProps>) {
  return <MUIMenuItem {...props}>{children}</MUIMenuItem>;
}
